// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Popup_container__D-wHs {
  padding: 56px;
  text-align: center;
}

.Popup_container-no-padding__snFus {
  text-align: center;
}`, "",{"version":3,"sources":["webpack://./src/components/common/Popup/Popup.module.scss"],"names":[],"mappings":"AAAA;EACE,aAAA;EACA,kBAAA;AACF;;AAEA;EACE,kBAAA;AACF","sourcesContent":[".container {\n  padding: 56px;\n  text-align: center;\n}\n\n.container-no-padding {\n  text-align: center;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `Popup_container__D-wHs`,
	"container-no-padding": `Popup_container-no-padding__snFus`
};
export default ___CSS_LOADER_EXPORT___;
